import { isValid } from "date-fns";

import {
  dateTimeStringToDateTime,
  formatHeaderDateString,
} from "lib/timeFormats";

export enum CopyBidderDirection {
  FROM = "from",
  TO = "to",
}

export interface CopyBidderSaleOption {
  value: number;
  label: string;
  title: string;
  detail: string;
}

interface BuildCopyBidderSaleOptionsArgs {
  sales: Record<string | number, Sale>;
  currentLivestockSaleId: number | null;
  direction: CopyBidderDirection;
  hasWriteAccessBySaleId: Record<string | number, boolean>;
}

export function getSaleName(sale: Pick<Sale, "sale_title" | "sale_type">) {
  return sale.sale_title || sale.sale_type || "Sale";
}

export function buildCopyBidderSaleOptions({
  sales,
  currentLivestockSaleId,
  direction,
  hasWriteAccessBySaleId,
}: BuildCopyBidderSaleOptionsArgs): CopyBidderSaleOption[] {
  return Object.values(sales)
    .map(sale => ({ sale, saleDate: dateTimeStringToDateTime(sale.date) }))
    .filter(
      ({ sale, saleDate }) =>
        sale.using_registered_bidders &&
        sale.livestocksale_id !== currentLivestockSaleId &&
        isValid(saleDate) &&
        (direction === CopyBidderDirection.FROM ||
          hasWriteAccessBySaleId[sale.livestocksale_id]),
    )
    .sort((a, b) => b.saleDate.getTime() - a.saleDate.getTime())
    .map(({ sale, saleDate }) => {
      const title = getSaleName(sale);
      const detail = [formatHeaderDateString(saleDate), sale.saleyard_name]
        .filter(Boolean)
        .join(" - ");
      return {
        value: sale.livestocksale_id,
        label: `${title} - ${detail}`,
        title,
        detail,
      };
    });
}
